import React, { useState } from "react";
import "./home.scss";
import { Paper, InputBase, IconButton } from "@mui/material";
import { BsSearch } from "react-icons/bs";
import { Statistique } from "../../components/Statistique/Statistique";

const HomePage = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="home">
      <div className="search">
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 400,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Recherche ..."
            inputProps={{ "aria-label": "search google maps" }}
            onChange={(e) => setSearch(e.target.value.toLocaleLowerCase())}
          />
          <IconButton sx={{ p: "10px" }} aria-label="search">
            <BsSearch />
          </IconButton>
        </Paper>
      </div>
      <div className="content">
        <Statistique />
      </div>
    </div>
  );
};

export default HomePage;
